import { 
    CreateVehicleTransactionDto, 
    DeleteVehicleTransactionDto,
    EditVehicleTransactionDto,
    GetVehicleTransactionDto, 
    MessageResponseDto, 
    VehicleTransactionApiFp,
    VehicleTransactionControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseVehicleTransactionModel = VehicleTransactionControllerGet200Response;
export type GetVehicleTransactionModel = GetVehicleTransactionDto;
export type MutateResponseVehicleTransactionModel = MessageResponseDto;
export type CreateVehicleTransactionModel = CreateVehicleTransactionDto;
export type UpdateVehicleTransactionModel = EditVehicleTransactionDto;
export type DeleteVehicleTransactionModel = DeleteVehicleTransactionDto;

export const apiVehicleTransactionFp = VehicleTransactionApiFp(apiConfig);
export const getVehicleTransactionController = apiVehicleTransactionFp.vehicleTransactionControllerGet;
export const createVehicleTransactionController = apiVehicleTransactionFp.vehicleTransactionControllerCreate;
export const updateVehicleTransactionController = apiVehicleTransactionFp.vehicleTransactionControllerEdit;
export const deleteVehicleTransactionController = apiVehicleTransactionFp.vehicleTransactionControllerDelete;

export const QueryKeyVehicleTransaction = QueryKey.VehicleTransaction;